import Image from "next/image";
import React, { useState } from "react";
import FAQItem from "./HomeFaq/FAQItem";
import dynamic from "next/dynamic";

const LoadMoreButton = dynamic(() => import("../detail/LoadMoreButton"), {
  ssr: false,
});

const FrequentlyAskedQuestions = ({ faq }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [showAll, setShowAll] = useState(false);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const displayedFaqs = showAll ? faq?.data : faq?.data?.slice(0, 5);

  const handleShowAll = () => {
    setShowAll(!showAll);
  };
  
  return (
    <div className="lg:mb-[132px] md:mb-20 sm:mb-10 mb-5">
      <div className="container">
        <div className="flex lg:flex-nowrap flex-wrap lg:gap-[72px] md:gap-12 sm:gap-6 gap-3">
          <div className="w-full lg:w-2/5">
            <div className="flex items-center justify-center lg:justify-start">
              <Image
                src="/SSS.png"
                width={528}
                height={440}
                alt="sss"
                className="object-cover"
              />
            </div>
          </div>
          <div className="w-full lg:w-3/5">
            <h2 className="text-themeBlack sm:text-3xl text-xl font-light md:mb-7 mb-3 block">
              Sıkça Sorulan <span className="font-semibold">Sorular</span>
            </h2>
            <div className="flex flex-col gap-y-2">
              {displayedFaqs?.map((faq, index) => (
                <FAQItem
                  key={faq.id}
                  faq={faq}
                  onClick={() => handleToggle(index)}
                  isOpen={activeIndex === index}
                />
              ))}
            </div>
            <div className="mt-3 lg:mt-7">
              {faq?.data?.length > 5 && (
                <LoadMoreButton onClick={handleShowAll} showAll={showAll} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FrequentlyAskedQuestions;
